import * as React from 'react';
import styled from 'styled-components';
import { IconClose } from '../icon/IconClose';

interface Props {
  onClose: () => void;
  title: string;
  zIndex?: number;
}

const Bg = styled.div<{ zIndex?: number}>`
  backdrop-filter: blur(0.15rem) grayscale(40%);
  background: rgba(0, 0, 0, 0.3);
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: ${(props) => props.zIndex ?? 1};
`;

const Popup = styled.div<{ zIndex?: number}>`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const Header = styled.header`
  border-radius: 0.3rem 0.3rem 0 0;
  position: relative;
`;

const HeaderLbl = styled.label`
  color: #fff;
  display: block;
  font-size: 1.1rem;
  font-weight: bold;
  letter-spacing: 0.05rem;
  padding: 1rem;
`;

const Close = styled.div`
  height: 2rem;
  width: 2rem;

  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);

  :hover {
    cursor: pointer;
  }
`;

const P = (props: Props & { children: any }) => (
  <Bg zIndex={props.zIndex}>
    <Popup>
      <Header className="popup__header-background-color">
        <Close onClick={props.onClose}>
          <IconClose style={{ fill: '#fff' }} />
        </Close>
        <HeaderLbl>{props.title}</HeaderLbl>
      </Header>

      {props.children}
    </Popup>
  </Bg>
);

export default P;
